import { render } from "./CustomerHome.vue?vue&type=template&id=16e587ff&scoped=true"
import script from "./CustomerHome.vue?vue&type=script&lang=js"
export * from "./CustomerHome.vue?vue&type=script&lang=js"

import "./CustomerHome.vue?vue&type=style&index=0&id=16e587ff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16e587ff"]])

export default __exports__